import { render, staticRenderFns } from "./update_org.vue?vue&type=template&id=98348cae&scoped=true&"
import script from "./update_org.vue?vue&type=script&lang=js&"
export * from "./update_org.vue?vue&type=script&lang=js&"
import style0 from "./update_org.vue?vue&type=style&index=0&id=98348cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98348cae",
  null
  
)

export default component.exports